export default {
    url: '/stream-series-energy-saving-calculator',
    include: ['de', 'fr', 'eu', 'uk', 'it', 'es'],
};
